
export default {
    name: 'viewApplyBook',
    title: '查看参赛申请书',
    component: () => import('../../../views/dialog/ApplyBookViewer'),
    buttons:true
}
